import { IAppState } from '../../redux';

import { selectIsPromotionPackageSelected } from './selectIsPromotionPackageSelected';
import { selectIsWithoutMinimalBet } from './selectIsWithoutMinimalBet';
import { selectIsServicesEnabled } from './selectIsServicesEnabled';

// пока идет эксперимент MONEY-382 используем признак эксперимента withoutMinimalBet
export const selectIsWithoutServices = (state: IAppState): boolean => {
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);
  const isWithoutMinimalBet = selectIsWithoutMinimalBet(state);
  const isServicesEnabled = selectIsServicesEnabled(state);

  return isWithoutMinimalBet && !isPromotionPackageSelected && !isServicesEnabled;
};
